import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('blu-7436-separate-growth-rec');
	},
};
